import { useEffect, useState } from 'react';

import Image from 'react-bootstrap/Image';

import Menu from '../../components/MenuFair4Them';

import header from '../../images/f4t-header.png'

import constantes from '../../helpers/constanteHelper';

function SobreFair4Them() {
    const [width, setWidth] = useState(window.innerWidth);


    function observarMudancaWidth() {
        setWidth(window.innerWidth);
    }

    useEffect(() => {
        window.addEventListener('resize', observarMudancaWidth);

        // Scroll para o topo da página para melhor visualização no mobile ou em resoluções menores
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })

        return () => {
            window.removeEventListener('resize', observarMudancaWidth);
        }
    }, []);

    const resolucaoMobile = width <= constantes.RESPONSIVIDADE.LARGURA_MOBILE;

    return (
        <>
            <div style={{ minHeight: '100vh', background: constantes.CORES.COR_FAIR4THEM }} className='text-center d-flex flex-column align-items-center'>
                <Menu opcaoSelecionada={'sobre'} />
                <div className='animate__animated animate__fadeIn d-flex flex-column align-items-center'>
                    <div style={{ height: resolucaoMobile ? '20px' : '80px' }}></div>

                    <Image style={{ height: '600px', objectFit: 'contain', padding: '20px' }} src={header} alt='logo' fluid />
                    <h1 className={resolucaoMobile ? 'mb-5' : 'mt-5 mb-5'} style={{ color: constantes.CORES.BRANCO_PADRAO, fontWeight: 700 }}>Certificação Fair4Them</h1>

                    <span className='mb-5' style={{ width: resolucaoMobile ? '90vw' : '70vw', color: constantes.CORES.BRANCO_PADRAO, fontSize: '20px', whiteSpace: 'pre-line', textAlign: resolucaoMobile ? 'justify' : 'center' }}>
                        Um convite para fazer parte da nova era de tutoria responsável.<br /><br />
                        Inovações em soluções de nutrição, saúde e bem-estar dos animais de companhia ajudarão a atender às mais recentes demandas dos tutores responsáveis. As certificações da Fair4Them são voltadas para oferecer segurança nas escolhas, com base em valores como transparência, responsabilidade e confiança.<br /><br />
                        Os produtos e serviços certificados como Fair4Them - Bem-estar Animal, seja para cães, gatos ou equinos, podem estar relacionados a um ou mais domínios, ou liberdades do Bem-estar Animal. Além disso, um ponto importante é que as análises são feitas com base em publicações e artigos científicos, de acordo com cada espécie. 
                    </span>

                </div>
            </div>
        </>
    );
}

export default SobreFair4Them;
